module.exports = __webpack_public_path__ + "static/media/S1N6-5.24b08813.svg";